export const checkoutMethodOptions = {
  PICKUP: 'pickup',
  DELIVERY: 'delivery',
  GLACIAL_DELIVERY: 'glacial_delivery',
  STANDARD_TRANSFER: 'standard_transfer',
};
